import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Form, Input, Button, Row, Col, notification } from 'antd';
import { ArrowLeftOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import logo from 'assets/images/logo__paye-black.svg';
import authService from 'services/auth.services';
import MaskedInput from 'react-input-mask';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const ConnectUs = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const body = {
        nameSurname: values.nameSurname,
        email: values.email,
        phone: `90${values.phone
          .replace(/\)/g, '')
          .replace(/\(/g, '')
          .replace(/-/g, '')
          .replace(/ /g, '')}`,
        message: values.message,
      };
      await authService.sendSupport(body);
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Formunuz Gönderildi.',
      });
      navigate('/login');
    } catch (error) {
      notification.error({
        message: 'İşlem Başarısız',
        description: error.message || 'Bir hata oluştu.',
      });
    }
  };

  return (
    <div className="register-page flex-row align-items-center">
      <div style={{ maxWidth: '1000px', minHeight: '550px' }} className="register-card">
        <div style={{ display: 'block' }} className="register-form-wrapper">
          <h1 className="register-title">
            <NavLink to="/login">
              <span className="back-icon">
                <ArrowLeftOutlined />
              </span>
            </NavLink>
            Bize Ulaşın
          </h1>
          <Row>
            <Col span={10} offset={1}>
              <img src={logo} alt="Paye Kart" style={{ width: '30%', marginBottom: '30px' }} />
              <h3 style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                Sofra Kurumsal ve Ödüllendirme Hizmetleri A.Ş.
              </h3>
              <div style={{ marginBottom: '30px' }}>
                Turkcell Tepebaşı Plaza, Asmalı Mescit Mahallesi Meşrutiyet Cad. No:71 Beyoğlu /
                İSTANBUL
              </div>
              <PhoneOutlined />
              <span> Çağrı Merkezi: 0850 477 7293 </span>
              <div style={{ marginBottom: '10px' }} />
              <MailOutlined />
              <span> E-posta : destek@payekart.com.tr </span>
            </Col>
            <Col span={10} offset={2}>
              <Form
                {...layout}
                form={form}
                onFinish={handleSubmit}
                style={{ width: '150%' }}
                name="nest-messages"
              >
                <Form.Item
                  name="nameSurname"
                  rules={[{ required: true, message: 'Ad Soyad giriniz!' }]}
                >
                  <Input style={{ height: '44px' }} placeholder="Ad Soyad" />
                </Form.Item>
                <Form.Item
                  name="email"
                  rules={[{ type: 'email', required: true, message: 'Email giriniz!' }]}
                >
                  <Input style={{ height: '44px' }} placeholder="E-Posta" />
                </Form.Item>
                <Form.Item
                  name="phone"
                  rules={[
                    {
                      min: 10,
                      max: 20,
                      required: true,
                      message: 'Telefon numarası giriniz!',
                    },
                  ]}
                >
                  <MaskedInput mask="(999) 999 99 99">
                    {() => (
                      <Input style={{ height: '44px' }} maxLength={20} placeholder="Gsm Numarası" />
                    )}
                  </MaskedInput>
                </Form.Item>
                <Form.Item
                  name="message"
                  rules={[
                    {
                      required: true,
                      message: 'Mesaj giriniz!',
                    },
                  ]}
                >
                  <Input.TextArea style={{ height: '100px' }} placeholder="Mesajınız" />
                </Form.Item>
                <Form.Item
                  style={{ marginLeft: '100px' }}
                  wrapperCol={{ ...layout.wrapperCol, offset: 8 }}
                >
                  <Button className="button button__fill" type="primary" htmlType="submit">
                    GÖNDER
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ConnectUs;
